export default {
  CustomerTitle: 'Customer',
  buttonnewCustomer: 'New Customer Item',
  buttonnewCustomerDepartment: 'New Customer Department',
  buttonDeleteCustomer: 'Delete Customer',
  buttonDeleteCustomerDepartment: 'Delete Customer Department',
  newCustomer: 'New Customer',
  editCustomer: 'Edit Customer',
  newCustomerDepartment: 'New Customer Department',
  editCustomerDepartment: 'Edit Customer Department',
  CustomerName: 'Customer Name',
  confirmDelete: 'Are you sure you want to delete Customer {}?',
  confirmCustomerDepartmentDelete: 'Are you sure you want to delete Customer Department {}?',
  confirmDeleteSelected: 'Are you sure you want to delete selected Customer?',
  confirmCustomerDepartmentDeleteSelected: 'Are you sure you want to delete selected Customer Department?',
  progressMessageDelete: 'Deleting Customer {}',
  progressMessageCustomerDepartmentDelete: 'Deleting Customer Department {}',
  messageDeleteNotSelected: 'Please select Customer to delete',
  messageDeleteDepartmentNotSelected: 'Please select Customer Department to delete',
  tabWindow: 'Window',
  tabDepartment: 'Department',
  AddPicture: 'Add Picture',
  CustomerDetail: 'Customer Detail',
  copyHeader: 'Copy From Header',
}
